const matterTime = {
	d(time){
		var x = 1000 * 60 * 60 * 24
		return time * x
	},
	h(time){
		var x = 1000 * 60 * 60 
		return time * x
	},
	m(time){
		var x = 1000 * 60 
		return time * x
	},
	s(time){
		var x = 1000 
		return time * x
	}
}
function handleTime (time){
	var t = Date.now();
	if(typeof time === "object"){
		// 时间格式 几天几时几分几秒
		var keys = Object.keys(time)
		t += keys.reduce((prev,key)=>{
			if(matterTime[key]){
				prev += matterTime[key](time[key])
			}
			return prev
		}, 0)
	}else if(String(time).length > 9 && String(time).length < 14){
		// 定点 - 时间戳
		if(String(time).length < 12){
			t = time * 1000
		}else{
			t = time
		}
	}else{
		// 几秒后到期
		t = t + matterTime.s(time)
		console.log(t,"t");
	}
	return t
}

export default class rewriteCache {
	constructor() {
		this.uniSetStorage = uni.setStorage
		this.uniSetStorageSync = uni.setStorageSync
		this.uniGetStorage = uni.getStorage
		this.uniGetStorageSync = uni.getStorageSync
		this.uniRemoveStorage = uni.removeStorage

		this.autoClearObj = this.uniGetStorageSync("autoClearObj") || Object.create(null) // 自动清除对象信息
		this.setTimeMap = Object.create(null)
	}
	/**
	 * @param {Object} params
	 * @param {Object} autoClearParams 三种形式 秒数，定点时间戳，对象形式 => d,h,m,s
	 */
	setStorage(params, autoClearParams) {
		var time = handleTime(autoClearParams) 
		this.uniSetStorage(params)
		if (autoClearParams) { // 是否自动清除判断
			this.addTimer({
				timer: time,
				key: params.key
			})
		}
	}
	/**
	 * @param {Object} params
	 * params.timer 到期时间戳
	 * params.key local/key
	 */
	addTimer(params) {
		this.autoClearObj[params.key] = params.timer // 总缓存
		this.uniSetStorage({
			key: "autoClearObj",
			data: this.autoClearObj,
			success: () => {
				this.start()
			}
		})
	}
	removeTimer(key) {
		delete this.autoClearObj[key]
		this.uniSetStorage({
			key: "autoClearObj",
			data: this.autoClearObj
		})
		this.uniRemoveStorage({key});
	}
	// 开启定时器
	start() {
		const vm = this
		for (let key in this.autoClearObj) {
			const endTimer = this.autoClearObj[key]
			const startTimer = this.getCurrentTimer()
			const time = endTimer - startTimer
			
			if (time > 0) {
				this.setTimeMap[key] = setTimeout(() => {
					this.removeTimer(key)
					clearTimeout(this.setTimeMap[key])
				}, time)
			} else {
				// 排查到过期时间
				this.removeTimer(key)
				if (this.setTimeMap[key]) {
					clearTimeout(this.setTimeMap[key])
				}
			}
		}
	}
	getCurrentTimer() {
		var time = Date.now()
		return time
	}
}
